import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { ReferralService } from '../referral.service'

@Component({
  selector: 'app-referral-shell',
  templateUrl: './referral-shell.component.html',
  styleUrls: ['../referrals.component.scss'],
})
export class ReferralShellComponent implements OnInit {
  referralState$ = this.referralService.referrals$
  commissionRate$ = this.referralService.referralsCommissionRate$
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private referralService: ReferralService
  ) {}
  id: string
  ngOnInit() {
    const id = this.activatedRoute.snapshot.params.id
  }
  OnUpdateCommission(event: number) {
    this.referralService.updateCommission(event)
  }
}
